export default __webpack_public_path__ + "static/media/students.67b3245f.jpg";